import axios from "axios";
import { CONST } from "../config/const";

export interface Inquiry {
  id: number;
  account_id: number;
  category: string;
  subject: string;
  content: string;
  image_s3_key?: string | null;
  status: string;
  created_at: string;
  updated_at: string;
  closed_at: string | null;
  vendor_company_name?: string;
}

export async function getInquiries(
  status?: string
): Promise<{ inquiries: Inquiry[]; total: number } | null> {
  try {
    const params: { [key: string]: string | number } = {};
    if (status) params.status = status;
    const response = await axios.get(CONST.apiUrl2 + "inquiries", { params });
    return response.data;
  } catch (error) {
    return null;
  }
}

export async function getInquiry(
  id: number
): Promise<{ inquiry: Inquiry } | null> {
  try {
    const response = await axios.get(CONST.apiUrl2 + `inquiry/${id}`);
    return response.data;
  } catch (error) {
    return null;
  }
}

export async function postInquiry(addData: {
  category: string;
  subject: string;
  content: string;
  image_s3_key?: string;
}) {
  try {
    const path = "inquiry";
    const bodys = { addData };
    const response = await axios.post(CONST.apiCognitoUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

